import { useRef, useState } from "react";
import { Check, FolderClosed, X } from "lucide-react";
import { placeholderProjects } from "./placeholderProjects.js";
import { useComposerMenu } from "./useComposerMenu.js";

// 欢迎页项目选择 chip —— 视觉占位,使用假数据,未接真实项目 API(Issue #30 接入真实逻辑)。
// 选择只存在本组件 local state:不持久化、不改变会话归属、不触发任何后端调用。
// 可见性完全由 CSS 控制(默认隐藏,仅 .app-shell.welcome-mode 下显示),因此无需向
// Composer/ChatPage 传 isWelcome,也不越界改 features/chat 或会话链路。
export function ProjectChip() {
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const menu = useComposerMenu({ open, setOpen, triggerRef, menuRef });
  const selected = placeholderProjects.find((project) => project.id === selectedId) ?? null;

  return (
    <div className="composer-project" data-placeholder="true">
      <button
        ref={triggerRef}
        type="button"
        className="composer-project-chip"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-controls="composer-project-menu"
        onClick={() => open ? menu.closeMenu() : menu.openMenu()}
        onKeyDown={menu.onTriggerKeyDown}
      >
        <FolderClosed className="composer-project-icon" size={14} />
        <span>{selected ? selected.name : "选择项目"}</span>
      </button>
      {open && (
        <div
          ref={menuRef}
          id="composer-project-menu"
          className="composer-project-menu"
          role="listbox"
          aria-label="选择项目(占位)"
          onKeyDown={menu.onMenuKeyDown}
        >
          {placeholderProjects.map((project) => (
            <button
              key={project.id}
              type="button"
              role="option"
              aria-selected={project.id === selectedId}
              className="composer-project-option"
              onClick={() => {
                setSelectedId(project.id);
                menu.closeMenu();
              }}
            >
              <FolderClosed className="composer-project-icon" size={14} />
              <span>{project.name}</span>
              {project.id === selectedId && <Check className="composer-project-check" size={14} />}
            </button>
          ))}
          <div className="composer-project-divider" />
          <button
            type="button"
            role="option"
            aria-selected={selectedId === null}
            className="composer-project-option is-muted"
            onClick={() => {
              setSelectedId(null);
              menu.closeMenu();
            }}
          >
            <X className="composer-project-icon" size={14} />
            <span>不使用项目</span>
          </button>
        </div>
      )}
    </div>
  );
}
